import React from 'react';

const InputWrap = ({ children }) => {
    return <div className={'input-wrap'}>{children}</div>;
};

export default InputWrap;
